export default function getCalendarDates(monthOffset = 0, dt=null) {
  const now = dt || new Date();
  const year = now.getFullYear();
  const target = new Date(year, now.getMonth() + monthOffset, 1);

  const firstDay = new Date(target.getFullYear(), target.getMonth(), 1);
  const lastDay = new Date(target.getFullYear(), target.getMonth() + 1, 0);
  const days = [];

  const dayOfWeek = firstDay.getDay();

  // Days from previous month
  for (let i = dayOfWeek; i > 0; i--) {
    const prevDate = new Date(target.getFullYear(), target.getMonth(), 1 - i);
    days.push({
      day: prevDate.getDate(),
      month: prevDate.getMonth(),
      year: prevDate.getFullYear(),
      isCurrentMonth: false
    });
  }

  // Current month days
  for (let d = 1; d <= lastDay.getDate(); d++) {
    days.push({
      day: d,
      month: target.getMonth(),
      year: target.getFullYear(),
      isCurrentMonth: true
    });
  }


  return {
    monthLabel: target.toLocaleString('default', { month: 'long', year: 'numeric' }),
    days,
    month: target.getMonth(),
    year: target.getFullYear()
  };
}

